/**
 * Admin de plataforma — criterio (LoginPage / CallbackPage):
 * userRole === "admin" ⟺ email @microcentrum.cl y no es invitado@microcentrum.cl
 *
 * Nota: el flag en localStorage es UX; las APIs sensibles deben validar en backend.
 */
export const isPlatformAdmin = () => {
  try {
    return localStorage.getItem("userRole") === "admin";
  } catch (error) {
    console.error("Error al leer userRole:", error);
    return false;
  }
};
